import React, { Fragment } from "react";
import Sidebar from "../components/Sidebar/Sidebar";
import routes from "../routes";
import AdminNav from "../components/Navbars/AdminNavbar";
import PaymentMethodHeader from "../components/PaymentMethod/PaymentMethodHeader";
import StripeIntegration from "../components/PaymentMethod/StripeIntegration";

export default function StripeIntegrationPage() {
  return (
    <Fragment>
      <Sidebar routes={routes} />
      <div className="main-panel">
        <AdminNav />
        <div className="content">
          <div className="addcustomers">
            <div className="row cslocation paymentPage customers">
              <div className="col-sm-12">
                <h2>Stripe Integration</h2>
              </div>

              <div className="col-sm-12 height-adjust">
                <StripeIntegration />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}
